import RepsIcon from '../../assets/svgs/majesticons_repeat-circle.svg';
import { getCounterBackground } from '../../features/exercise/helpers';
import TimerOrCounter from '../timer-or-counter';
import tw from 'twin.macro';

const Counter = ({
  isFalseStage,
  counterCurrentValue,
  counterTotal,
  icon,
  hasCounter,
  minutes,
  seconds,
}) => {
  const backgroundStyle = getCounterBackground(isFalseStage);

  return (
    <div tw="rounded-[10px] gap-6 flex items-center py-[20px] px-[20px]" css={[backgroundStyle]}>
      {/* shrink-0 + explicit box: without it the flex row squeezes the icon
          whenever the number beside it grows a digit. */}
      <img
        loading="lazy"
        decoding="async"
        src={icon || RepsIcon}
        alt="Reps icon"
        width={31}
        height={31}
        tw="h-[31px] w-[31px] shrink-0"
      />
      <TimerOrCounter
        hasCounter={hasCounter}
        counterCurrentValue={counterCurrentValue}
        counterTotal={counterTotal}
        minutes={minutes}
        seconds={seconds}
      />
    </div>
  );
};

export default Counter;
